import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const blockUserFromPartnerAction = createAsyncThunk(
    'block-user-from-partner',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/block-user-from-partners?p_user_id=${data?.p_user_id}&partner=${data.partner}&publisher_id=${data.publisher_id}&user_id=${data.user_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const blockUserFromPartnerSlice = createSlice({
    name: 'block-user-from-partner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(blockUserFromPartnerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(blockUserFromPartnerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(blockUserFromPartnerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const blockUserFromPartnerReducer = blockUserFromPartnerSlice.reducer